<template>
  <div class="parking-area-info app-region blank-b-v blank-l-h blank-r-h" :class="{'blank-t-v': !id}">
    <a-form-model class="app-form" ref="form" :model="form" :rules="rules" :labelCol="$formLabelCol" :wrapperCol="$formWrapperCol" v-if="!id">
      <a-form-model-item label="发布社区" prop="community">
        <a-select v-model="form.community" placeholder="请选择发布社区" :disabled="!isPlatformRole">
          <a-select-option :value="value.id" v-for="value in communityOptions" :key="value.id">{{value.name}}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="分区名称" prop="name">
        <a-input v-model="form.name" placeholder="请输入分区名称" allow-clear></a-input>
      </a-form-model-item>
      <a-form-model-item label="车位数量" prop="count">
        <a-input-number v-model="form.count" placeholder="请输入车位数量" :min="1" allow-clear></a-input-number>
      </a-form-model-item>
      <a-form-model-item label="起始编号" prop="number">
        <a-input-number v-model="form.number" placeholder="请输入起始编号" :min="0" allow-clear></a-input-number>
      </a-form-model-item>
      <a-form-model-item label="编号规则" prop="rule">
        <a-radio-group v-model="form.rule">
          <a-radio :value="1">数字编号</a-radio>
          <a-radio :value="2">前缀+数字编号</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="编号前缀" prop="prefix" v-if="form.rule === 2">
        <a-input v-model="form.prefix" placeholder="请输入编号前缀" allow-clear></a-input>
      </a-form-model-item>
      <a-form-model-item :wrapper-col="$formEmptyLabelWrapperCol">
        <a-space>
          <a-button type="primary" @click="nextStep">下一步</a-button>
          <a-button @click="cancel">取消</a-button>
        </a-space>
      </a-form-model-item>
    </a-form-model>
    <a-spin tip="加载中..." :spinning="loading" v-else>
      <div class="page-title">
        <a-space>{{name}}</a-space>
      </div>
      <a-row type="flex" :gutter="[16, 16]">
        <a-col :span="24" :xl="3" v-for="value in data" :key="value.id">
          <a-row class="item" :class="{'disabled': value.state === 2}" type="flex" justify="space-between">
            <a-col>{{value.name}}</a-col>
            <a-col>
              <a-dropdown>
                <a-icon type="ellipsis"></a-icon>
                <a-menu slot="overlay">
                  <a-menu-item @click="renameParking(value)">重命名</a-menu-item>
                  <a-menu-item @click="enableParking(value)" v-if="value.state === 2">启用</a-menu-item>
                  <a-menu-item @click="disableParking(value)" v-else>禁用</a-menu-item>
                </a-menu>
              </a-dropdown>
            </a-col>
          </a-row>
        </a-col>
      </a-row>
    </a-spin>
    <a-modal :title="modal.title" :confirm-loading="modal.loading" v-model="modal.show" @ok="confirmModal" destroy-on-close centered>
      <a-form-model ref="modalForm" :model="modal.form" layout="vertical" :rules="modal.rules">
        <a-form-model-item label="车位名称" prop="name">
          <a-input v-model="modal.form.name" placeholder="请输入车位名称" allow-clear></a-input>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
  import CommunityService from '@/io/community.js';
  import ParkingService from '@/io/parking.js';

  export default {
    name: 'ParkingAreaInfo',
    props: {
      initId: {
        type: Number,
        default: null
      },
    },
    data() {
      return {
        loading: false,
        communityId: this.$route.query.community_id,
        id: this.$route.params.id,
        communityOptions: [],
        form: {
          community: [],
          name: null,
          count: null,
          number: null,
          rule: null,
          prefix: null
        },
        rules: {
          community: [
            {
              required: true,
              message: '请选择发布社区'
            }
          ],
          name: [
            {
              required: true,
              message: '请输入分区名称'
            }
          ],
          count: [
            {
              required: true,
              message: '请输入车位数量'
            }
          ],
          number: [
            {
              required: true,
              message: '请输入起始编号'
            }
          ],
          rule: [
            {
              required: true,
              message: '请选择编号规则'
            }
          ],
          prefix: [
            {
              required: true,
              message: '请输入编号前缀'
            }
          ],
        },
        name: null,
        data: [],
        modal: {
          id: null,
          title: '重命名车位',
          show: false,
          loading: false,
          form: {
            name: null
          },
          rules: {
            name: [
              {
                required: true,
                message: '请输入车位名称'
              }
            ],
          }
        },
      }
    },
    watch: {
      initId: {
        handler(newValue, oldValue) {
          if (newValue) {
            this.id = newValue;
          }
        },
        immediate: true
      },
      id: {
        handler(newValue, oldValue) {
          this.initCommunity().then(() => {
            this.initPage();
          });
        },
        immediate: true
      }
    },
    methods: {
      enableParking(data) {
        ParkingService.enable(data.id).then(res => {
          this.initPage();
        }).catch(err => {});
      },
      disableParking(data) {
        ParkingService.disable(data.id).then(res => {
          this.initPage();
        }).catch(err => {});
      },
      renameParking(data) {
        this.modal.id = data.id;
        this.modal.form.name = data.name;
        this.modal.show = true;
      },
      confirmModal() {
        this.$beforeFormSubmit(this.$refs.modalForm, () => {
          this.modal.loading = true;
          ParkingService.update(this.modal.id, this.modal.form.name).then(res => {
            this.$afterFormSubmit('编辑成功', () => {
              this.initPage();
            });
          }).catch(err => {}).finally(() => {
            this.modal.show = false;
            this.modal.loading = false;
          });
        });
      },
      initPage() {
        if (this.$getCookie('communityId')) {
          this.form.community = [this.$getCookie('communityId') * 1];
        }
        if (this.id) {
          this.loading = true;
          ParkingService.listPage(this.communityId, [this.id]).then(res => {
            this.data = res;
            this.name = res[0].car_port_garage.name;
          }).catch(err => {}).finally(() => {
            this.loading = false;
          });
        }
      },
      initCommunity() {
        return CommunityService.listPage().then((res) => {
          this.communityOptions = res;
        }).catch((err) => {});
      },
      nextStep() {
        this.$beforeFormSubmit(this.$refs.form, () => {
          ParkingService.addArea(
            this.form.community,
            this.form.name,
            this.form.count,
            this.form.number,
            this.form.rule,
            this.form.prefix
          ).then(res => {
            this.$afterFormSubmit('创建成功', () => {
              this.communityId = this.form.community;
              this.id = res.id;
            });
          }).catch(err => {});
        });
      },
      cancel() {
        this.$router.push({
          name: 'ParkingManage'
        });
      }
    },
  }
</script>

<style lang="less" scoped>
  @import '../../assets/styles/tools.less';
  .parking-area-info {
    .item {
      background-color: @background-color-base;
      padding: @padding-sm @padding-lg;
      &.disabled {
        opacity: .6;
      }
    }
  }
</style>